<template>
  <div>
    <div class="columns">
      <div class="column is-12">
        <div class="columns">
          <div class="tabs is-boxed">
            <ul>
              <li
                  v-for="(tab, i) in tabs"
                  :class="{ 'is-active': activeTab.key === tab.key }"
                  @click="setActiveTab(tab);"
              >
                <a v-if="evaluate(tab.condition)">
                  <span class="icon is-small">
                      <i
                          class="fa"
                          :class="tab.icon"
                      />
                  </span>
                  <span>{{ $t(`settings.campground.${tab.key}`) }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="edit-box box-shadow">
          <div class="columns">


            <div
                v-if="activeTab.key === 'payment'"
                class="column is-12"
            >


              <!-- Zahlarten-Bereich: Stellplätze und Mietobjekte nebeneinander -->
              <div class="columns is-variable is-3">
                <div class="column is-12 is-6-desktop">
                  <div class="box-shadow p-2">
                    <div>
                    <h2>{{ $t('settings.deposit.header_pitches') }}</h2>
                    <div class="mt-2">
                        <label class="label">{{ $t('settings.payment.systemLabel') }}</label>
                        <div class="select">
                          <select v-model="value.payment_system_pitches">
                               <option v-for="(label, value) in $t('settings.payment.systems')"
                                        v-if="value !== 'ONLINE'"
                                        :key="value"
                                        :value="value">
                                    {{ label }}
                                </option>
                          </select>
                        </div>
                    </div>

                    <div class="mt-2">
                        <h3 class="mb-2">{{ $t('settings.deposit.headline') }}</h3>
                        <p>{{ $t('settings.deposit.copy') }}</p>
                        <p>
                          <slider class="settings__deposit__slider" v-model="value.deposit_percent"
                                  :min="depositInfo.min_percent" :max="depositInfo.max_percent"
                                  :step="5" @change="updateDeposit"></slider>
                          <span class="settings__deposit__percent">{{ value.deposit_percent }} %</span>
                        </p>
                    </div>

                    <div class="mb-2">
                      <div class="columns">
                          <div class="column is-6">
                            <label for="accommodation_minimum_fixed_deposit" class="label edit-box__includes-inline-input">{{
                                $t('settings.deposit.fixed.labels.campsites')
                              }}</label>
                          </div>
                          <div class="column is-6 text-with-input">
                            <form-input id="minimum_fixed_deposit" class="edit-box__inline-input is-inline"
                                        v-model="value.minimum_fixed_deposit"
                                        :options="{ inputtype: 'number', min: 0, step: 1 }"
                                        :error="formErrors.minimum_fixed_deposit">
                            </form-input>

                            <span class="edit-box__includes-inline-input is-inline-block">{{
                                $getDefaultCurrency().symbol
                              }}</span>
                          </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>

                <div class="column is-12 is-6-desktop">
                  <div class="box-shadow p-2">
                    <div>
                      <h2>{{ $t('settings.deposit.header_rentals') }}</h2>
                      <div class="mt-2">
                        <label class="label">{{ $t('settings.payment.systemLabel') }}</label>
                        <div class="select">
                          <select v-model="value.payment_system_rentals">
                                <option v-for="(label, value) in $t('settings.payment.systems')"
                                        v-if="value !== 'ONLINE'"
                                        :key="value"
                                        :value="value">
                                    {{ label }}
                                </option>
                          </select>
                        </div>
                    </div>


                    <div class="mt-2">
                        <h3 class="mb-2">{{ $t('settings.deposit.headline') }}</h3>
                        <p>{{ $t('settings.deposit.copy_rental') }}</p>
                        <p>
                          <slider class="settings__deposit__slider" v-model="value.accommodation_deposit_percent"
                                  :min="depositInfo.min_percent" :max="depositInfo.max_percent"
                                  :step="5" @change="updateAccommodationDeposit"></slider>
                          <span class="settings__deposit__percent">{{ value.accommodation_deposit_percent }} %</span>
                        </p>
                    </div>

                    <div class="columns">
                      <div class="column is-6">
                        <label for="minimum_fixed_deposit" class="label edit-box__includes-inline-input">{{
                            $t('settings.deposit.fixed.labels.accommodations')
                          }}</label>
                      </div>
                      <div class="column is-6 text-with-input">
                        <form-input id="accommodation_minimum_fixed_deposit" class="edit-box__inline-input is-inline"
                                    v-model="value.accommodation_minimum_fixed_deposit"
                                    :options="{ inputtype: 'number', min: 0, step: 1 }"
                                    :error="formErrors.accommodation_minimum_fixed_deposit">
                        </form-input>

                        <span class="edit-box__includes-inline-input is-inline-block">{{
                            $getDefaultCurrency().symbol
                          }}</span>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="box-shadow mt-2 p-2" v-if="value.payment_system_pitches === 'ONLINE' || value.payment_system_rentals === 'ONLINE'">
                <h1>{{ $t('settings.payment.providerConfigLabel')}}</h1>

                <div class="is-variable is-4">
                <!-- Zahlungsanbieter + Hinweis nebeneinander -->
                  <div class="columns is-6 is-horizontal is-align-items-center">
                      <div class="column">
                      <div class="field-label is-normal">
                        <label class="label">{{ $t('settings.payment.providerLabel')}}</label>
                      </div>
                      <div class="field-body">
                        <div class="field is-narrow">
                          <div class="control">
                            <div class="select">
                              <select v-model="value.payment_provider" @change="handleProviderChange">
                                <option value="">{{ $t('settings.payment.noProvider') }}</option>
                                <option value="STRIPE">Stripe</option>
                              </select>
                            </div>
                          </div>
                          <p v-if="formErrors.payment_provider" class="help is-danger">
                            {{ Array.isArray(formErrors.payment_provider) ? formErrors.payment_provider[0] : formErrors.payment_provider }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="column" v-if="value.payment_provider === 'STRIPE'">
                      <div class="notification is-info is-light mb-0">
                        Verbinden Sie Ihr Konto mit Stripe, um Onlinezahlungen zu akzeptieren.
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="value.payment_provider === 'STRIPE'" class="mt-3">

                  <!-- Statusanzeige -->
                  <div class="field" v-if="value.payment_provider_config && value.payment_provider_config.connected">
                    <label class="label">Status</label>
                    <p class="control">
                      <span class="tag is-success">Mit Stripe verbunden</span>
                      <span v-if="value.payment_provider_config.account_name" class="ml-2">
                        ({{ value.payment_provider_config.account_name }})
                      </span>
                    </p>
                  </div>

                  <!-- Hauptaktion: abhängig von account_id entweder Admin öffnen oder verbinden -->
                  <div class="field">
                    <template v-if="hasStripeAccountId">
                      <button class="button is-primary" @click.prevent="connectStripe">
                        Stripe Admin öffnen
                      </button>
                      <p class="help">Das Stripe‑Dashboard wird in einem neuen Tab geöffnet.</p>
                    </template>
                    <template v-else>
                      <button class="button is-primary"
                              :class="{ 'is-loading': stripeConnectLoading }"
                              @click.prevent="connectStripe">
                        Mit Stripe verbinden / registrieren
                      </button>
                      <p class="help">Sie werden zu Stripe weitergeleitet, um die Registrierung/Verknüpfung abzuschließen.</p>
                    </template>
                  </div>

                  <!-- Provider-Status / Details -->
                  <div class="box mt-3" v-if="stripeProviderState">
                    <h2 class="title is-6 mb-3">Stripe‑Konto Status</h2>

                    <!-- Oberer Statusbereich -->
                    <div class="mb-3">
                      <span class="tag"
                            :class="{
                              'is-success': stripeProviderState.connected && stripeProviderState.status === 'active',
                              'is-warning': stripeProviderState.status && stripeProviderState.status !== 'active',
                              'is-light': !stripeProviderState.status
                            }">
                        {{ stripeProviderState.status || (stripeProviderState.connected ? 'verbunden' : 'nicht verbunden') }}
                      </span>
                      <span v-if="stripeProviderState.status_message" class="ml-2 has-text-grey">
                        {{ stripeProviderState.status_message }}
                      </span>
                    </div>

                    <!-- Capabilities -->
                    <div v-if="stripeProviderState.capabilities" class="mb-4">
                      <label class="label is-small">Funktionen</label>
                      <div class="tags">
                        <span class="tag" :class="stripeProviderState.capabilities.charges_enabled ? 'is-success' : 'is-light'">
                          Zahlungen
                        </span>
                        <span class="tag" :class="stripeProviderState.capabilities.payouts_enabled ? 'is-success' : 'is-light'">
                          Auszahlungen
                        </span>
                        <span class="tag" :class="stripeProviderState.capabilities.details_submitted ? 'is-success' : 'is-light'">
                          Angaben vollständig
                        </span>
                      </div>
                    </div>

                    <div class="columns is-variable is-4">
                      <div class="column is-12 is-6-desktop">
                        <!-- Business Infos -->
                        <div v-if="stripeProviderState.business" class="mb-4">
                          <label class="label is-small">Unternehmen</label>
                          <div class="content is-small">
                            <p v-if="stripeProviderState.business.name">
                              <strong>Name:</strong>
                              <span class="ml-1">{{ stripeProviderState.business.name }}</span>
                            </p>
                            <p v-if="stripeProviderState.business.url">
                              <strong>Website:</strong>
                              <a class="ml-1" target="_blank"
                                 :href="(stripeProviderState.business.url || '').match(/^https?:\/\//) ? stripeProviderState.business.url : ('https://' + stripeProviderState.business.url)">
                                {{ stripeProviderState.business.url }}
                              </a>
                            </p>
                            <p v-if="stripeProviderState.business.email">
                              <strong>E‑Mail:</strong>
                              <a class="ml-1" :href="'mailto:' + stripeProviderState.business.email">{{ stripeProviderState.business.email }}</a>
                            </p>
                          </div>
                        </div>

                        <!-- Bankkonto -->
                        <div v-if="stripeProviderState.bank_account" class="mb-4">
                          <label class="label is-small">Auszahlungskonto</label>
                          <div class="content is-small">
                            <p v-if="stripeProviderState.bank_account.bank_name">
                              <strong>Bank:</strong>
                              <span class="ml-1">{{ stripeProviderState.bank_account.bank_name }}</span>
                            </p>
                            <p v-if="stripeProviderState.bank_account.last4">
                              <strong>Konto:</strong>
                              <span class="ml-1">•••• {{ stripeProviderState.bank_account.last4 }}</span>
                            </p>
                            <p>
                              <span v-if="stripeProviderState.bank_account.country"><strong>Land:</strong><span class="ml-1">{{ stripeProviderState.bank_account.country }}</span></span>
                              <span v-if="stripeProviderState.bank_account.currency" class="ml-3"><strong>Währung:</strong><span class="ml-1">{{ stripeProviderState.bank_account.currency }}</span></span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="column is-12 is-6-desktop">
                        <!-- Auszahlungsrhythmus -->
                        <div v-if="stripeProviderState.payouts" class="mb-4">
                          <label class="label is-small">Auszahlungsrhythmus</label>
                          <div class="content is-small">
                            <p v-if="stripeProviderState.payouts.description">
                              {{ stripeProviderState.payouts.description }}
                            </p>
                            <p v-else>
                              <span v-if="stripeProviderState.payouts.interval"><strong>Intervall:</strong><span class="ml-1">{{ stripeProviderState.payouts.interval }}</span></span>
                              <span v-if="stripeProviderState.payouts.delay_days !== undefined" class="ml-3"><strong>Verzögerung:</strong><span class="ml-1">{{ stripeProviderState.payouts.delay_days }} Tage</span></span>
                            </p>
                          </div>
                        </div>

                        <!-- Weitere Angaben -->
                        <div class="is-size-7">
                          <p v-if="stripeProviderState.statement_descriptor">
                            <strong>Kontoauszug‑Bezeichnung:</strong>
                            <span class="ml-1">{{ stripeProviderState.statement_descriptor }}</span>
                          </p>
                          <p v-if="stripeProviderState.account_id" class="mt-1">
                            <strong>Account‑ID:</strong>
                            <code class="ml-1" style="word-break: break-all;">{{ stripeProviderState.account_id }}</code>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>



            <div
                v-if="activeTab.key === 'images'"
                class="column is-12"
            >
              <div class="mb-5">
                <h3>
                  {{ $t('settings.campground.logoImage') }}
                  <span class="btn btn-primary" @click="toggleImageChange('logo')">
                    <i class="fa fa-pencil" />
                  </span>
                </h3>
                <ImageSort
                    v-if="images.logo.length && !imageChange.logo"
                    v-model="images.logo"
                    is-single-image
                    is-campground-image
                    image-type="logo"
                />
                <ImageUpload
                    v-else
                    hide-title
                    is-single-image
                    is-campground-image
                    image-type="logo"
                    @uploaded="uploadedImage('logo', 'logo')"
                />
              </div>
              <div class="mb-5">
                <h3>
                  {{ $t('settings.campground.logoBooking') }}
                  <span class="btn btn-primary" @click="toggleImageChange('logoBooking')">
                    <i class="fa fa-pencil" />
                  </span>
                </h3>
                <ImageSort
                    v-if="images.logoBooking.length && !imageChange.logoBooking"
                    v-model="images.logoBooking"
                    is-single-image
                    is-campground-image
                    image-type="logo_booking"
                />
                <ImageUpload
                    v-else
                    hide-title
                    is-single-image
                    is-campground-image
                    image-type="logo_booking"
                    @uploaded="uploadedImage('logoBooking', 'logo_booking')"
                />
              </div>
              <div class="mb-5">
                <h3>
                  {{ $t('settings.campground.logoEmail') }}
                  <span class="btn btn-primary" @click="toggleImageChange('logoEmail')">
                    <i class="fa fa-pencil" />
                  </span>
                </h3>
                <ImageSort
                    v-if="images.logoEmail.length && !imageChange.logoEmail"
                    v-model="images.logoEmail"
                    is-single-image
                    is-campground-image
                    image-type="logo_email"
                />
                <ImageUpload
                    v-else
                    hide-title
                    is-single-image
                    is-campground-image
                    image-type="logo_email"
                    @uploaded="uploadedImage('logoEmail', 'logo_email')"
                />
              </div>
              <div>
                <h3>
                  {{ $t('settings.campground.imagesList') }}
                  <span class="btn btn-primary" @click="toggleImageChange('list')">
                    <i class="fa fa-pencil" />
                  </span>
                </h3>
                <ImageSort
                    v-if="images.list.length && !imageChange.list"
                    v-model="images.list"
                    is-campground-image
                    image-type="list"
                />
                <ImageUpload
                    v-else
                    hide-title
                    is-campground-image
                    image-type="list"
                    @uploaded="uploadedImage('list', 'list')"
                />
              </div>
            </div>
            <div
                v-else-if="activeTab.key === 'campground'"
                class="column is-12"
            >

             <div class="column is-12">
                <div class="content mt-5">
                  <h3>{{ $t('settings.campground.name_and_address') }}</h3>
                </div>

                 <div class="columns">
                     <div class="column col-6">
                         <div class="column is-12">
                            <label for="cg_name">{{ $t('settings.campground.cg_name') }}</label>
                            <form-input v-model="value.cg_name" name="cg_name"/>
                        </div>
                         <div class="column is-12">
                            <label for="cg_street1">{{ $t('settings.campground.cg_street1') }}</label>
                            <form-input v-model="value.cg_street1" name="cg_street1"/>
                        </div>
                         <div class="column is-12">
                            <label for="cg_street2">{{ $t('settings.campground.cg_street2') }}</label>
                            <form-input v-model="value.cg_street2" name="cg_street2"/>
                        </div>
                         <div class="column is-12">
                            <label for="cg_zipcode">{{ $t('settings.campground.cg_zipcode') }}</label>
                            <form-input v-model="value.cg_zip_code" name="cg_zipcode"/>
                        </div>
                         <div class="column is-12">
                            <label for="cg_city">{{ $t('settings.campground.cg_city') }}</label>
                            <form-input v-model="value.cg_city" name="cg_city"/>
                        </div>
                         <div class="column is-12">
                            <label for="cg_country">{{ $t('settings.campground.cg_country') }}</label>
                             <select name="cg_country" id="cg_country" v-model="value.cg_country" class="input">
                                 <option v-for="(country, _) in countries" :value="country.key" :key="country.key">
                                    {{ country.name }}
                                </option>

                             </select>
                        </div>
                     </div>
                     <div class="column col-6">
                         <div class="column is-12">
                            <label for="cg_phone">{{ $t('settings.campground.cg_phone') }}</label>
                            <form-input v-model="value.cg_phone" name="cg_phone"/>
                        </div>
                         <div class="column is-12">
                            <label for="cg_email">{{ $t('settings.campground.cg_mail') }}</label>
                            <form-input v-model="value.cg_email" name="cg_email"/>
                        </div>

                        <div class="content mt-5 ml-3">
                            <h3>{{ $t('settings.campground.gpsTitle') }}</h3>
                        </div>

                         <div class="column is-12">
                            <label for="cg_geo_lat">{{ $t('settings.campground.latitude') }}</label>
                            <form-input
                                v-model="value.cg_geo_lat"
                                name="cg_geo_lat"
                            />
                        </div>
                        <div class="column is-12">
                            <label for="cg_geo_lng">{{ $t('settings.campground.longitude') }}</label>
                            <form-input
                                v-model="value.cg_geo_lng"
                                name="cg_geo_lng"
                            />
                        </div>
                     </div>
                 </div>

             </div>


              <div class="column is-12">
                <div class="content">
                  <h3>{{ $t('settings.campground.descriptionsTitle') }}</h3>
                </div>
                <label for="cg_description">{{ $t('settings.campground.long_text') }}</label>
                <wysiwyg
                    v-model="value.cg_description"
                    name="cg_description"
                />
              </div>
              <div class="column is-12">
                <label for="cg_short_description">{{ $t('settings.campground.short_text') }}</label>
                <wysiwyg
                    v-model="value.cg_short_description"
                    name="cg_short_description"
                />
              </div>

              <div class="column is-12">
                <div class="content mt-5">
                  <h3>{{ $t('settings.contact.headline') }}</h3>
                  <p v-html="$t('settings.contact.copy')"></p>
                </div>
              </div>
              <div class="column is-12">
                <div class="columns">
                  <div class="column is-5">
                    <label for="email" class="label edit-box__includes-inline-input">{{
                        $t('settings.contact.email')
                      }}</label>
                  </div>
                  <div class="column is-7">
                    <form-input id="email" v-model="value.email" :error="formErrors.email"></form-input>
                  </div>
                </div>
              </div>

              <div class="column is-12">
                <div class="content mt-5">
                  <h3>{{ $t('settings.i18n.headline') }}</h3>
                  <p v-html="$t('settings.i18n.copy')"></p>
                </div>
              </div>

              <div class="column is-12">
                <div class="columns">
                  <div class="column is-5">
                    <label for="languages" class="label edit-box__includes-inline-input">
                      {{ $t('settings.i18n.base_language') }}
                    </label>
                  </div>
                  <div class="column is-7">
                    <p>
                      <strong>{{ getLanguageObjectByCode(value.base_language).name }}</strong>
                    </p>
                    <p>
                      <i v-html="$t('settings.i18n.base_language_info', {SERVICE_EMAIL_LINK: SERVICE_EMAIL_LINK})"></i>
                    </p>
                  </div>
                </div>

                <div class="columns">
                  <div class="column is-5">
                    <label for="languages" class="label edit-box__includes-inline-input">
                      {{ $t('settings.i18n.languages') }}
                    </label>
                  </div>
                  <div class="column is-7">
                    <multiselect
                        id="languages"
                        name="languages"
                        v-model="selectedLanguages"
                        :options="languages"
                        :multiple="true"
                        :searchable="false"
                        :hide-selected="true"
                        :placeholder="$t('settings.i18n.pleaseSelect')"
                        :close-on-select="false"
                        selectLabel=""
                        label="name"
                        track-by="name">
                    </multiselect>
                  </div>
                </div>

                <div class="columns is-multiline" v-if="currencyChangeEnabled">
                  <div class="column is-5">
                    <label for="email" class="label edit-box__includes-inline-input">
                      {{ $t('settings.i18n.currency') }}
                    </label>
                  </div>
                  <div class="column is-7">
                  <span class="select">
                      <select id="currency" v-model="selectedCurrency" name="currency"
                              @change="onCurrencySelected()">
                          <option v-for="(currency, _) in currencies" :value="currency.code"
                                  :key="currency.code">
                              {{ currency.name }}
                          </option>
                      </select>
                  </span>
                  </div>
                  <div class="column is-12" v-show="paymentChangeError" ref="paymentExist">
                    <article class="currency-error message is-warning">
                      <div class="message-header">
                        <p>{{ this.$t('bookingDetails.refund.title') }}</p>
                      </div>
                      <div class="message-body">
                        <!-- TODO: add translations -->
                        Leider konnten wir die Währung nicht ändern. Eine Änderung der Währung ist nur möglich wenn
                        Ihr komplettes Guthaben ausgezahlt ist. Eine aktuelle Übersicht finden sie unter:
                        <router-link :to="{ name: 'payments', params: {lang: lang} }" class="link">
                          {{ $t('generic.menu.payments') }}
                        </router-link>
                      </div>
                    </article>
                  </div>
                </div>
              </div>

              <div class="column is-12">
                <div class="content mt-5">
                  <h3>{{ $t('settings.billing.headline') }}</h3>
                  <p v-if="vatIdOptional">{{ $t('settings.billing.copyVatIdOptional') }}</p>
                  <p v-else>{{ $t('settings.billing.copyVatIdNotOptional') }}</p>
                </div>
              </div>

              <div class="column is-12">
                <p>
                  <textarea-autosize
                      class="input"
                      name="billing_address"
                      id="billing_address"
                      v-model="value.billing_address"
                      :min-height="142"
                      :max-height="400"
                      :placeholder="$t('settings.billing.placeholder')"
                      :class="{ 'is-danger' : formErrors.billing_address }"
                  ></textarea-autosize>
                  <span class="help is-danger" v-if="formErrors.billing_address"
                        v-html="toList(formErrors.billing_address)"></span>
                </p>
              </div>

              <div class="column is-12">
                <div class="columns">
                  <div class="column is-5">
                    <label for="email" class="label edit-box__includes-inline-input">{{
                        $t('settings.billing.companyName')
                      }}</label>
                  </div>
                  <div class="column is-7">
                    <form-input id="company_name" v-model="value.company_name"
                                :error="formErrors.company_name"></form-input>
                  </div>
                </div>
              </div>

              <div class="column is-12">
                <div class="columns">
                  <div class="column is-5">
                    <label for="email" class="label edit-box__includes-inline-input">{{
                        $t('settings.billing.email')
                      }}</label>
                  </div>
                  <div class="column is-7">
                    <form-input id="billing_email" v-model="value.billing_email"
                                :error="formErrors.billing_email"></form-input>
                  </div>
                </div>
              </div>

              <div
                  v-if="!vatIdOptional"
                  class="column is-12"
              >
                <div class="columns">
                  <div class="column is-4">
                    <label for="vat_id" class="label edit-box__includes-inline-input">
                      <span>{{ $t('settings.billing.vatId') }}</span>
                    </label>
                  </div>
                  <div class="column is-8">
                    <form-input id="vat_id" v-model="value.vat_id" :error="formErrors.vat_id"></form-input>
                  </div>
                </div>
              </div>

              <div
                  v-if="vatIdOptional"
                  class="column is-12"
              >
                <div class="column is-4">
                  <label for="vat_id" class="label edit-box__includes-inline-input">
                    <span>{{ $t('settings.billing.vatIdOptional') }}</span>
                  </label>
                </div>
                <div class="column is-8">
                  <form-input id="vat_id" v-model="value.vat_id" :error="formErrors.vat_id"></form-input>
                </div>
              </div>





            </div>
            <div
                v-else-if="activeTab.key === 'attributes'"
                class="column is-12"
            >
              <div class="columns">
                <div class="column">
                  <span class="label edit-box__includes-inline-input">
                      {{ $t('attributes.title') }}

                      <a
                          class="edit-button"
                          @click="toggleAttributesModal"
                      >
                          <i
                              aria-hidden="true"
                              class="fa fa-pencil-square-o fa-lg"
                          />
                      </a>
                  </span>
                </div>

                <Attributes
                    v-if="showAttributesModal"
                    :all-attributes="allAttributes"
                    :active-attributes="activeAttributes"
                    @toggle-modal="toggleAttributesModal"
                    @save="saveAttributes"
                />
              </div>
              <div
                  v-if="activeAttributes.length > 0"
                  class="columns"
              >
                <div class="column">
                  <ul class="attribute-list">
                    <li
                        :key="attribute.id"
                        v-for="attribute in activeAttributes"
                        class="attribute-item"
                    >
                      <i
                          class="fa fa-check-circle is-valid"
                          aria-hidden="true"
                      />
                      {{ attribute.name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
                v-else-if="activeTab.key === 'lockTimes'"
                class="column is-12"
            >
              <div class="columns">
                <div class="column is-5 label">
                  <p>{{ $t('bookings.from') }}</p>
                </div>
                <div class="column is-5 label">
                  <p>{{ $t('bookings.until') }}</p>
                </div>
              </div>

              <div
                  :key="lockTime.id"
                  v-for="lockTime in lockTimes"
                  class="columns"
              >
                <div class="column is-5 label">
                  <form-input
                      v-model="lockTime.locked_from"
                      class="settings__input"
                      :class="{ 'is-loading' : updatingLockTime }"
                      :options="{ inputtype: 'date' }"
                      @input="lockTime.didTimeUpdate = true"
                  />
                </div>
                <div class="column is-5 label">
                  <form-input
                      v-model="lockTime.locked_until"
                      class="settings__input"
                      :class="{ 'is-loading' : updatingLockTime }"
                      :options="{ inputtype: 'date' }"
                      @input="lockTime.didTimeUpdate = true"
                  />
                </div>
                <div class="column is-2 label">
                  <button
                      v-if="lockTime.didTimeUpdate"
                      class="settings__input--file-upload button is-success"
                      :class="{ 'is-loading' : updatingLockTime }"
                      @click="doUpdateLockTime(lockTime.locked_from, lockTime.locked_until, lockTime.id)"
                  >
                    <i class="fa fa-save" aria-hidden="true"/>
                  </button>
                  <button
                      v-else
                      class="settings__input--file-upload button is-danger"
                      :class="{ 'is-loading' : updatingLockTime }"
                      @click="removeLockTime(lockTime.id)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"/>
                  </button>
                </div>
              </div>

              <div class="columns">
                <template v-if="newLockTime">
                  <div class="column is-5 text-with-input">
                    <form-input
                        v-model="newLockTime.from"
                        class="settings__input"
                        :options="{ inputtype: 'date' }"
                    />
                  </div>
                  <div class="column is-5 text-with-input">
                    <form-input
                        v-model="newLockTime.until"
                        class="settings__input"
                        :options="{ inputtype: 'date' }"
                    />
                  </div>

                  <div class="column is-2 label">
                    <button
                        class="settings__input--file-upload button is-success"
                        :class="{ 'is-loading' : updatingLockTime }"
                        @click="saveLockTime(null)"
                    >
                      <i class="fa fa-save" aria-hidden="true"/>
                    </button>
                  </div>


                </template>

                <div
                    class="column is-8 text-with-input"
                    v-else
                >
                  <button
                      class="button is-primary"
                      :class="{ 'is-loading' : updatingLockTime }"
                      @click="initNewLockItem"
                  >
                    {{ $t('settings.lockTimes.add') }}
                  </button>
                </div>
              </div>
            </div>
            <div
                v-else-if="activeTab.key === 'rules'"
                class="column is-12"
            >
              <div class="columns">
                <div class="column is-12">
                  <div class="content">
                    <h3>{{ $t('settings.generalRules.headline') }}</h3>
                    <p>{{ $t('settings.generalRules.copy') }}</p>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-12">
                  <div class="columns">
                    <div class="column is-6">
                      <label for="accommodation_arrival_from" class="label edit-box__includes-inline-input">{{
                          $t('settings.generalRules.accommodationArrivalFrom')
                        }}</label>
                    </div>
                    <div class="column is-6 text-with-input">
                      <form-input id="accommodation_arrival_from" class="edit-box__inline-input is-inline is-time"
                                  v-model="value.accommodation_arrival_from" :options="{ inputtype: 'time' }"
                                  :error="formErrors.accommodation_arrival_from">
                      </form-input>
                      <span class="edit-box__includes-inline-input is-inline-block">Uhr</span>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-6">
                      <label for="accommodation_departure_until" class="label edit-box__includes-inline-input">{{
                          $t('settings.generalRules.accommodationDepartureUntil')
                        }}</label>
                    </div>
                    <div class="column is-6 text-with-input">
                      <form-input id="accommodation_departure_until" class="edit-box__inline-input is-inline is-time"
                                  v-model="value.accommodation_departure_until" :options="{ inputtype: 'time' }"
                                  :error="formErrors.accommodation_departure_until">
                      </form-input>
                      <span class="edit-box__includes-inline-input is-inline-block">Uhr</span>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-6">
                      <label for="arrival_from" class="label edit-box__includes-inline-input">{{
                          $t('settings.generalRules.arrivalFrom')
                        }}</label>
                    </div>
                    <div class="column is-6 text-with-input">
                      <form-input id="arrival_from" class="edit-box__inline-input is-inline is-time"
                                  v-model="value.arrival_from" :options="{ inputtype: 'time' }"
                                  :error="formErrors.arrival_from">
                      </form-input>
                      <span class="edit-box__includes-inline-input is-inline-block">Uhr</span>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-6">
                      <label for="departure_until" class="label edit-box__includes-inline-input">{{
                          $t('settings.generalRules.departureUntil')
                        }}</label>
                    </div>
                    <div class="column is-6 text-with-input">
                      <form-input id="departure_until" class="edit-box__inline-input is-inline is-time"
                                  v-model="value.departure_until" :options="{ inputtype: 'time' }"
                                  :error="formErrors.departure_until">
                      </form-input>
                      <span class="edit-box__includes-inline-input is-inline-block">Uhr</span>
                    </div>
                  </div>

                  <div class="columns">
                    <div class="column is-6">
                      <label for="book_same_day_until" class="label edit-box__includes-inline-input">{{
                          $t('settings.generalRules.bookSameDayUntil')
                        }}</label>
                    </div>
                    <div class="column is-6 text-with-input">
                      <form-input id="book_same_day_until" class="edit-box__inline-input is-inline is-time"
                                  v-model="value.book_same_day_until" :options="{ inputtype: 'time' }"
                                  :error="formErrors.book_same_day_until">
                      </form-input>
                      <span class="edit-box__includes-inline-input is-inline-block">Uhr</span>
                    </div>
                  </div>

                  <div class="columns">
                    <div class="column is-6">
                      <label for="book_same_day_accommodation_until" class="label edit-box__includes-inline-input">{{
                          $t('settings.generalRules.bookSameDayAccommodationUntil')
                        }}</label>
                    </div>
                    <div class="column is-6 text-with-input">
                      <form-input id="book_same_day_accommodation_until" class="edit-box__inline-input is-inline is-time"
                                  v-model="value.book_same_day_accommodation_until" :options="{ inputtype: 'time' }"
                                  :error="formErrors.book_same_day_accommodation_until">
                      </form-input>
                      <span class="edit-box__includes-inline-input is-inline-block">Uhr</span>
                    </div>
                  </div>

                  <div class="columns">
                    <div class="column is-6">
                      <label for="minimum_age_for_main_guest" class="label edit-box__includes-inline-input">{{
                          $t('settings.generalRules.minAgeForBooking')
                        }}</label>
                    </div>
                    <div class="column is-6 text-with-input">
                      <form-input id="book_same_day_accommodation_until" class="edit-box__inline-input is-inline is-time"
                                  v-model="value.minimum_age_for_main_guest" :options="{ inputtype: 'integer', min: 0, max: 9918}"
                                  :error="formErrors.minimum_age_for_main_guest">
                      </form-input>
                    </div>
                  </div>



                  <div class="columns">
                    <div class="column is-4">
                      <label for="toc_url" class="label edit-box__includes-inline-input">{{
                          $t('settings.generalRules.toc')
                        }}</label>
                    </div>
                    <div class="column is-8 text-with-input">
                      <form-input
                          id="toc_url"
                          v-model="value.toc_url"
                          class="settings__input"
                          :error="formErrors.toc_url"
                          placeholder="http://"
                          :options="{ inputtype: 'url' }"
                      />
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-4">
                      <label for="privacy_policy_url" class="label edit-box__includes-inline-input">{{
                          $t('settings.generalRules.privacyPolicy')
                        }}</label>
                    </div>
                    <div class="column is-8 text-with-input">
                      <form-input
                          id="privacy_policy_url"
                          v-model="value.privacy_policy_url"
                          class="settings__input"
                          :error="formErrors.privacy_policy_url"
                          placeholder="http://"
                          :options="{ inputtype: 'url' }"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns">
                <div class="column is-12">
                  <div class="content mt-5">
                    <h3>{{ $t('settings.additionalRules.headline') }}</h3>
                    <p v-html="$t('settings.additionalRules.copy') "></p>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-12">
                  <div class="is-clearfix">
                    <wysiwyg v-model="value.additional_rules" :options="wysiwygOptions"></wysiwyg>
                  </div>
                </div>
              </div>
            </div>
            <div
                v-else-if="activeTab.key === 'documents'"
                class="column is-12"
            >
              <div class="column is-12 is-12-desktop">
                <div class="content">
                  <h3>Ihre akzeptierten Dokumente</h3>
                  <p>Hier können Sie Ihre bereits akzeptieren Dokumente nochmals einsehen</p>

                  <ul v-if="campground && campground.legal_documents.accepted">
                    <li v-for="doc in campground.legal_documents.accepted">
                      <h3>{{ doc.legal_document.name }}, {{ $t('dashboard.legal_documents.valid_from') }}
                        {{ doc.legal_document.valid_from }}</h3>
                      <div>
                        <p>{{ doc.legal_document.info_text }}<br>
                          Akzeptiert am {{ doc.accepted_at }} von {{ doc.accepted_by }}<br>
                          <a :href="doc.legal_document.documents.terms_of_service" target="_blank">
                            <span>{{ $t('dashboard.legal_documents.tos') }}</span>
                          </a>
                          <span> & </span>
                          <a :href="doc.legal_document.documents.order_processing_conditions" target="_blank">
                            <span>{{ $t('dashboard.legal_documents.opc') }}</span>
                          </a>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" :class="{ 'is-active': showCurrencyModal }">
      <div class="modal-background" @click="closeCurrencyModal()"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title" v-html="$t('settings.i18n.currencyModal.title')"></p>
          <button class="delete" @click="closeCurrencyModal()"></button>
        </header>
        <section class="modal-card-body" v-html="$t('settings.i18n.currencyModal.content')"></section>
        <footer class="modal-card-foot is-clearfix">
          <a class="button" @click="closeCurrencyModal()">{{ $t('generic.cancel') }}</a>
          <a class="button is-success" @click="closeCurrencyModal(true)">
                        <span class="icon">
                            <i class="fa fa-check-circle" aria-hidden="true"></i>
                        </span>
            <span>{{ $t('settings.i18n.currencyModal.submit') }}</span>
          </a>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { FormInput, ImageSort, ImageUpload, Wysiwyg } from '../index';
import { AppModel } from '../../../models';
import Attributes from '../attributes';
import { Api } from '../../../api';
import { EventBus } from '../../../utils';
import { cloneDeep, debounce } from 'lodash';
import Multiselect from 'vue-multiselect';
import ArrayFilters from '../../../filters/ArrayFilters';
import Slider from 'vue-bulma-slider';

export default {
    name: 'campground-settings',
    components: {
        Slider,
        Multiselect,
        Attributes,
        FormInput,
        ImageSort,
        ImageUpload,
        Wysiwyg,
    },
    props: [
        'currencyChangeEnabled',
        'currencies',
        'formErrors',
        'languages',
        'value',
    ],
    data() {
        return {
            campground: AppModel.activeCampground,
            owner_frontend_config: {},
            activeTab: {
                key: 'campground',
                icon: '',
            },
            tabs: [
                {
                    key: 'campground',
                    icon: 'fa-id-card',
                },
                {
                    key: 'rules',
                    icon: 'fa-pencil',
                },
                {
                    key: 'lockTimes',
                    icon: 'fa-lock',
                },
                {
                    key: 'payment',
                    icon: 'fa-credit-card',
                },
                {
                    key: 'attributes',
                    icon: 'fa-star',
                },
                {
                    key: 'images',
                    icon: 'fa-picture-o',
                },
                {
                    key: 'documents',
                    icon: 'fa-file-text',
                },
            ],
            showAttributesModal: false,
            allAttributes: [],
            attributeCategories: [],
            newLockTime: null,
            updatingLockTime: false,
            lockTimes: [],
            SERVICE_EMAIL_LINK: AppModel.serviceEmailLink,
            showCurrencyModal: false,
            depositInfo: AppModel.depositInfo,
            updateDepositTrackingTimeout: null,
            settingsBeforeChangesApply: null,
            wysiwygOptions: {
                maxChars: 600,
                placeholder: this.$t('settings.additionalRules.placeholder'),
            },
            selectedLanguages: [],
            selectedCurrency: null,
            countries: AppModel.countries,
            images: {
                logo: [],
                logoBooking: [],
                logoEmail: [],
                list: [],
            },
            imageChange: {
                logo: false,
                logoBooking: false,
                logoEmail: false,
                list: false,
            },
            // Stripe
            stripeConnectLoading: false,
        };
    },
    async created() {
        if(this.$route.query.tab) {
            this.activeTab.key = this.$route.query.tab;
        }

        this.attributeCategories = (await Api.attributes.getActiveCampsites()).data;
        this.allAttributes = (await Api.attributes.getAllCampsites()).data;
        this.updateLockTime = debounce(this.updateLockTime.bind(this), 1000);
        await this.fetchLockTimes();
        this.onSettingsFetched(this.value);

        if(this.campground.images.logo) {
            this.images.logo.push(this.campground.images.logo);
        }
        if(this.campground.images.logo_email) {
            this.images.logoEmail.push(this.campground.images.logo_email);
        }
        if(this.campground.images.logo_booking) {
            this.images.logoBooking.push(this.campground.images.logo_booking);
        }
        if(this.campground.images.list) {
            this.images.list.push(...this.campground.images.list);
        }
    },
    watch: {
        selectedLanguages(newVal) {
            let hasBaseLanguage = false;
            newVal.forEach((lang) => {
                if(lang.code === this.value.base_language) {
                    hasBaseLanguage = true;
                }
            });
            if(!hasBaseLanguage) {
                this.selectedLanguages.unshift(this.getLanguageObjectByCode(this.value.base_language));
            }
        },
    },
    computed: {
        activeAttributes() {
            if(this.attributeCategories && this.attributeCategories.length >= 0) {
                return this.attributeCategories.map((categories) => categories.attributes).flat();
            }

            return [];
        },
        // Vereinheitlichte Quelle für den Stripe-Provider-Zustand: unterstützt sowohl provider_state als auch payment_provider_state
        stripeProviderState() {
            const v = this.value || {};
            return v.provider_state || v.payment_provider_state || null;
        },
        // Hat das Stripe-Konto bereits eine Account-ID? Steuert Hauptaktionsbutton
        hasStripeAccountId() {
            const s = this.stripeProviderState;
            return !!(s && s.account_id);
        },
        lang() {
            return AppModel.lang;
        },

        vatIdOptional() {
            return this.country === 'de';
        },

        paymentChangeError() {
            const paymentChangeError = this.formErrors.currency && this.formErrors.currency[ 0 ] === 'payments exist';

            // if payment can't be changed, show warning div and scroll it into view
            if(paymentChangeError) {
                this.$nextTick(() => {
                    this.selectedCurrency = this.settingsBeforeChangesApply.currency;
                    this.$refs.paymentExist.scrollIntoView({ behavior: 'smooth' });
                });
            }
            return paymentChangeError;
        },
    },
    methods: {
        evaluate(str) {
            if(typeof str !== 'string') return true;
            // eslint-disable-next-line no-eval
            return eval(str);
        },
        async uploadedImage(type = 'logo', urlType = 'logo') {
            const img = await Api.campgroundImages.fetchImages(urlType);

            if(type === 'list') {
                this.images[type] = [...img.data];
            } else {
                this.images[type] = [img.data.url];
            }

            this.imageChange[type] = false;
        },
        toggleImageChange(type = 'logo') {
            this.imageChange[type] = !this.imageChange[type];
        },
        setActiveTab(tab) {
            this.activeTab = tab;
            this.$router.push({ query: { tab: tab.key } });
        },
        getLanguageObjectByCode(code) {
            let langObject = {
                code: code,
                name: code,
            };
            this.value.languages.forEach((lang) => {
                if(lang.code === code) {
                    langObject = lang;
                }
            });
            return langObject;
        },

        toggleAttributesModal() {
            this.showAttributesModal = !this.showAttributesModal;
        },
        async saveAttributes(attributes) {
            const updatedAttributes = (await Api.attributes.setCampsites(attributes)).data;
            this.toggleAttributesModal();
            this.attributeCategories = updatedAttributes;
            EventBus.$emit(EventBus.SHOW_NOTIFICATION, {
                title: `<h3>${this.$t('generic.saveSuccessHeadline')}</h3>`,
                direction: 'Up',
                body: this.$t('generic.saveSuccess'),
            });
        },
        initNewLockItem() {
            this.newLockTime = {
                from: null,
                to: null,
            };
        },
        saveLockTime(id) {
            this.updatingLockTime = true;
            this.addNewLockTime();
        },
        doUpdateLockTime(from, until, lockTimeId) {
            this.updatingLockTime = true;
            this.updateLockTime(from, until, lockTimeId);
            Api.bootstrap(true);
        },
        showLockTimeError(response) {
            if(response.status > 201) {
                EventBus.$emit(EventBus.SHOW_NOTIFICATION,
                    {
                        title: this.$t('generic.formErrorHeadline'),
                        body: response.body,
                        direction: 'Up',
                        type: 'danger',
                        duration: 10000,
                    });
            }
        },
        async addNewLockTime() {
            if(this.newLockTime.from && this.newLockTime.until) {
                this.updatingLockTime = true;
                let res = await Api.lockTimes.createLockTime({
                    campground_slug: AppModel.activeCampground.slug,
                    'locked_from': this.newLockTime.from,
                    'locked_until': this.newLockTime.until,
                });
                this.showLockTimeError(res);
                await this.fetchLockTimes();
                this.updatingLockTime = false;
                this.newLockTime = null;
            }
        },
        async fetchLockTimes() {
            this.lockTimes = (await Api.lockTimes.getLockTimes()).data.map(lockTime => {
                lockTime.didTimeUpdate = false;

                return lockTime;
            });
        },
        async updateLockTime(from, until, lockTimeId) {
            this.updatingLockTime = true;
            let res = await Api.lockTimes.changeLockTime({
                campground_slug: AppModel.activeCampground.slug,
                'locked_from': from,
                'locked_until': until,
                id: lockTimeId,
            });
            this.showLockTimeError(res);
            await this.fetchLockTimes();
            this.updatingLockTime = false;
        },
        async removeLockTime(lockTimeId) {
            this.updatingLockTime = true;
            await Api.lockTimes.deleteLockTime(lockTimeId);
            await this.fetchLockTimes();
            this.updatingLockTime = false;
        },
        onCurrencySelected() {
            this.showCurrencyModal = this.selectedCurrency !== this.value.currency;
        },
        toList(v) {
            return ArrayFilters.toList(v);
        },
        updateDeposit(val) {
            this.value.deposit_percent = parseInt(val);
        },
        updateAccommodationDeposit(val) {
            this.value.accommodation_deposit_percent = parseInt(val);
        },
        onSettingsFetched(data) {
            /**
       * warning:
       * This only clones initially fetched data.
       * This is used to handle the currency change and might only be useful in that case because
       * currency change triggers a reload of the page.
       */
            this.settingsBeforeChangesApply = cloneDeep(data);
            this.owner_frontend_config = data.owner_frontend_config;
            this.$set(this.value, 'languages', data.languages);
            this.selectedCurrency = data.currency;
            this.selectedLanguages = [];
            data.languages.forEach((lang) => {
                this.selectedLanguages.push(this.getLanguageObjectByCode(lang.code));
            });

            this.setPaymentData();
        },
        handleProviderChange(event) {
            // event.target.value enthält den neuen Wert
            if(this.value.payment_provider === 'STRIPE') {
                // Initialisiere ein leeres Konfig-Objekt für Stripe (ohne API-Key Felder)
                if(this.value.payment_provider_config === null) {
                    this.value.payment_provider_config = {};
                }
            }
            console.log('Neuer Wert:', this.value.payment_provider);
        },
        async connectStripe() {
            try {
                this.stripeConnectLoading = true;
                // Falls das Backend bereits eine Onboarding-URL in der Konfiguration liefert, nutze diese
                let url = (this.value && this.value.payment_provider_config && this.value.payment_provider_config.onboarding_url) || null;
                if(!url) {
                    const res = await Api.payment.getStripeOnboardingUrl();
                    console.log('Stripe Onboarding-URL:', res);
                    const data = (res && (res.data || res.body)) || null;
                    if(data && typeof data === 'object') {
                        url = data.url || data.onboarding_url || (data.data && (data.data.url || data.data.onboarding_url)) || null;
                    } else if(typeof data === 'string') {
                        url = data;
                    } else if(res && typeof res === 'string') {
                        url = res;
                    }
                }
                if(url) {
                    window.open(url, '_blank');
                } else {
                    this.$toast && this.$toast.open({
                        message: 'Konnte Stripe Onboarding‑URL nicht ermitteln. Bitte später erneut versuchen.',
                        type: 'is-danger',
                    });
                }
            } catch (e) {
                console.error(e);
                this.$toast && this.$toast.open({
                    message: 'Fehler beim Abrufen der Stripe Onboarding‑URL.',
                    type: 'is-danger',
                });
            } finally {
                this.stripeConnectLoading = false;
            }
        },
        async openStripeDashboard() {
            try {
                // Verwende Dashboard‑URL, falls vorhanden, ansonsten vom Backend abrufen, Fallback: allgemeines Dashboard
                let url = (this.value && this.value.payment_provider_config && this.value.payment_provider_config.dashboard_url) || null;
                if(!url) {
                    try {
                        const res = await Api.payment.getStripeDashboardUrl();
                        const data = (res && (res.data || res.body)) || null;
                        if(data && typeof data === 'object') {
                            url = data.url || data.dashboard_url || (data.data && (data.data.url || data.data.dashboard_url)) || null;
                        } else if(typeof data === 'string') {
                            url = data;
                        } else if(res && typeof res === 'string') {
                            url = res;
                        }
                    } catch (e) {
                        // still try fallback
                    }
                }
                window.open(url || 'https://dashboard.stripe.com/', '_blank');
            } catch (e) {
                console.error(e);
                this.$toast && this.$toast.open({
                    message: 'Fehler beim Öffnen des Stripe‑Dashboards.',
                    type: 'is-danger',
                });
            }
        },
        setPaymentData() {
            if(!this.value.payment) {
                this.value.payment = {};
            }
            if(!this.value.payment.bank) {
                this.value.payment.bank = {};
            }
            if(!this.value.payment.card) {
                this.value.payment.card = {};
            }
            if(this.paymentDataType === 'bank') {
                this.paymentData = this.value.payment.bank;
            } else {
                this.paymentData = this.value.payment.card;
            }
        },
        closeCurrencyModal(keepCurrency = false) {
            if(!keepCurrency) {
                this.selectedCurrency = this.value.currency;
            }
            this.showCurrencyModal = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.tabs {
  width: 100%;
}

// SCSS mainly inherited from settings.scss
.attribute-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.attribute-item {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  flex-basis: 32%;
}

.w120 {
    width: 120px;
}


</style>



// WEBPACK FOOTER //
// src/views/components/campground-settings/index.vue